// src/components/HeroCover.jsx
import React from "react";
import { Box, Container, Grid, Typography, Paper, Link } from "@mui/material";
import GetEBookButton from "./GetEBookButton";
// Use theme from App via ThemeProvider; avoid local ThemeProvider here
const coverImage = "/assets/cyj-ebook.jpeg";

export default function HeroCover() {
  return (
      <Box component="section" sx={{  bgcolor: 'background.default', color: 'text.primary', marginBottom: 5 }}>
        <Box  sx={{ width: '100%'}}>
          <Grid container spacing={4} alignItems="flex-start">
            {/* LEFT: copy column */}
            <Grid item xs={12} md={7}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {/* Headline (Playfair, 38px per snippet) */}
                <Typography
                  component="h2"
                  sx={{
                    typography: 'h1',
                    fontSize: { xs: '2rem', md: '2.375rem' },
                    fontWeight: 700,
                    color: 'text.primary',
                    mb: 1,
                  }}
                >
                  <strong>
                    Happy US: A Parental Guide to Raising Joyful, Resilient &amp; Hopeful Kids
                  </strong>
                </Typography>

                {/* Sub-head (Crimson Text, 20px) */}
                <Typography
                  component="h3"
                  sx={{
                    typography: 'h3',
                    fontSize: { xs: '1rem', md: '1.25rem' },
                    fontWeight: 500,
                    color: 'text.primary',
                  }}
                >
                  <strong>
                    A heart-led, science-backed guide trusted by over 1,000 parents worldwide for raising emotionally strong kids and enjoying the process, too.
                  </strong>
                </Typography>

                {/* Paragraphs (Crimson Text 17px) */}
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: '0.9375rem', md: '1.0625rem' },
                      color: 'text.secondary',
                      mt: 2,
                    }}
                    paragraph
                  >
                    <strong>Parenting DOESN’T come with a Manual… </strong>
                    But it can come with<strong><u> calm, clarity, and connection</u>. Every parent wants to raise emotionally strong, kind, and confident kids…</strong>
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: '0.9375rem', md: '1.0625rem' },
                      color: 'text.secondary',
                    }}
                    paragraph
                  >
                    However, most of them don’t realize that those traits can actually be taught through small, <strong>science-backed practices</strong> that easily integrate into everyday life.
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: '0.9375rem', md: '1.0625rem' },
                      color: 'text.secondary',
                      mt: 1,
                    }}
                    paragraph
                  >
                    That’s exactly what <strong>Happy US</strong> helps you do.
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: '0.9375rem', md: '1.0625rem' },
                      color: 'text.secondary',
                      mt: 1,
                    }}
                    paragraph
                  >
                    Rooted in the science of <strong>Positive Psychology</strong>, <em>Happy US</em> gives you simple printable activities, gentle rituals, and one-page practices you can do between breakfast and school that teach emotional intelligence and gratitude to your kids without stress.
                  </Typography>
                </Box>

                <GetEBookButton />

                {/* Rating line with image + score */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    mt: 2,
                    flexDirection: { xs: 'column', sm: 'row' },
                    textAlign: { xs: 'left', sm: 'inherit' },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '18px',
                      fontWeight: 700,
                      color: 'text.secondary',
                    }}
                  >
                    Applauded by readers worldwide:
                  </Typography>

                  {/* SVG star image from Systeme (kept as in snippet) */}
                  <Box
                    component="img"
                    src="/assets/hero-component-4.svg"
                    alt="stars"
                    loading="lazy"
                    width={160}
                    style={{ display: 'block' }}
                  />

                  <Typography
                    sx={{
                      fontSize: '20px',
                      fontWeight: 400,
                      color: 'text.secondary',
                      mt: { xs: 1, sm: 0 },
                    }}
                  >
                    <strong>(4.98)</strong>
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* RIGHT: image as in snippet (keep our cover path) */}
            <Grid item xs={12} md={5}>
              <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-end" } }}>
                <Paper
                  elevation={6}
                  sx={{
                    width: { xs: 260, sm: 320, md: 500 },
                    borderRadius: 3,
                    overflow: "hidden",
                    p: 2,
                    backgroundColor: 'background.paper',
                  }}
                >
                  <Box
                    component="img"
                    src={coverImage}
                    alt="Craft Your Journey cover"
                    sx={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                      borderRadius: 2,
                      boxShadow: "0 10px 30px rgba(15,23,32,0.08)",
                    }}
                  />
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
  );
}
